import React, {useEffect} from 'react';
import './Modal.scss';
import EditMessage from './EditMessage';
import {CloseIcon} from '../svg/index';

interface DeactivateEventTypeModalProps {
  isModalOpen: boolean;
  isValidComment: boolean;
  eventName: string;
  isActive: boolean; 
  close: () => void;
  confirm: () => void;
  messageChange: any;
}

const DeactivateEventTypeModal: React.FC<DeactivateEventTypeModalProps> = ({ isModalOpen, isValidComment, eventName, close, confirm, messageChange, isActive }) => {
  useEffect(() => {
    
      const closeOnEscapeKeyDown = (e: any) => {
        if ((e.charCode || e.keyCode) === 27) {
          close();
        }
      }
      document.addEventListener('keydown', closeOnEscapeKeyDown);
  
    return () => document.removeEventListener('keydown', closeOnEscapeKeyDown);
    
  }, [isModalOpen]);

  if (!isModalOpen) {
    return null;
  }
  return (
    <div className='modal'>
        <div className='modal-content'>
            <div className='text-wrapper'>
                <div className="header-wrapper">
                    <h2 className="header header_new"> { isActive ? "Deactivate " : "Reactivate "} {eventName}</h2>
                    <button className="close-icon" onClick={close}>
                        <CloseIcon />
                    </button>
                </div>
                <p className="reopen-text reopen_new">Are you sure you want to {isActive ? "deactivate" : "reactivate"} {eventName} event type?</p>
                <div key="reopenMessage" className="reopen-comment-fullWidth">
                   <EditMessage key="reopenMessageBox" type="" onMessageDataChange={messageChange} initialMessage={""} forModal={true} />
                </div>
                <div className='button-wrapper-start'>
                  <auro-button variant="primary" fluid onClick={confirm}
                  class={
                    isValidComment
                      ? ""
                      : "disabled"
                  }>
                      <span className="btnlabel-white">Yes, {isActive ? "Deactivate" : "Reactivate"} this event type</span>
                  </auro-button>
                </div>
            </div>            
        </div>
    </div>
    
  );
}

export default DeactivateEventTypeModal;